import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const PlatformPageWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const PlatformHeaderWrapper = styled.div`
    width: 100%;
    padding: 20px 30px 8px;
    flex-shrink: 0;
`;

export const PlatformGridWrapper = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;

    & > div {
        flex: 1;
        min-height: 0;
        width: 100%;
    }
`;

export const PlatformPageTitle = styled.h2`
    margin: 0 0 4px;
    font-size: 24px;
    color: ${(p) => p.theme.colors.pageTitle};
`;

export const PlatformPageSubtitle = styled.p`
    margin: 0 0 12px;
    color: #666;
    font-size: 14px;
    max-width: 720px;
`;

export const PlatformHeaderRow = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
`;

export const PlatformActions = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-left: auto;
`;

export const PlatformErrorBanner = styled.div`
    margin: 0 30px 12px;
    padding: 8px 12px;
    background: #fff1f0;
    color: #a8071a;
    border-radius: 4px;
    font-size: 13px;
`;

export const PlatformTabsNav = styled.nav`
    display: flex;
    width: 100%;
    border-bottom: 1px solid ${(p) => p.theme.colors.grayDefaultBorder};
    background: ${(p) => p.theme.basic.white};
    overflow-x: auto;
    flex-shrink: 0;

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const PlatformTabsInner = styled.div`
    display: flex;
    width: 100%;
    min-width: min-content;
    padding: 0 30px;
`;


export const PlatformHubCards = styled.div`
    border-top: 1px solid #e4e4e4;
    border-bottom: 1px solid #e4e4e4;
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
`;

export const PlatformHubCard = styled(Link)`
    flex: 1;
    min-width: 200px;
    text-decoration: none;
    color: inherit;
    cursor: pointer;

    &:hover {
        background-color: ${(p) => p.theme.colors.hoverBG};
    }

    @media screen and (max-width: 768px) {
        flex: auto;
        width: 50%;

        &:nth-child(even) .platform-hub-card-inner {
            border-right: none;
        }
    }

    &:last-child .platform-hub-card-inner {
        border-right: none;
    }
`;

export const PlatformHubCardInner = styled.div`
    margin: 15px 0;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #e4e4e4;
    padding: 0 16px;
    text-align: center;
`;

export const PlatformHubCardTitle = styled.div`
    color: ${(p) => p.theme.colors.summaryBoxTitle};
    font-size: ${(p) => p.theme.fontSizes.summaryBoxTitle};
    line-height: 16px;
`;

export const PlatformHubCardValue = styled.div`
    margin-top: 15px;
    color: ${(p) => p.theme.colors.primaryBlue};
    font-size: ${(p) => p.theme.fontSizes.summaryBoxData};
    font-weight: bold;
    line-height: 28px;
`;

export const PlatformHubCardHint = styled.div`
    margin-top: 8px;
    color: #757575;
    font-size: 12px;
    line-height: 16px;
    max-width: 220px;
`;
